// V.1.0.0 (2026-02-15)
// --- START OF FILE apps/reseye-web/src/components/NotificationPrompt.jsx ---
import React from 'react';
import '../styles/NotificationPrompt.css';

const NotificationPrompt = ({ isOpen, type, onConfirm, onCancel, t }) => {
    if (!isOpen) return null;

    const isConflict = type === 'conflict';

    return (
        <div className="prompt-overlay">
            <div className="prompt-card">
                <div className="prompt-header">
                    <div className="prompt-icon">
                        {isConflict ? '⚠️' : '🔔'}
                    </div>
                    <h3 className="prompt-title">
                        {isConflict ? t('notificationConflictTitle') : t('notificationEnableTitle')}
                    </h3>
                </div>
                <p className="prompt-message">
                    {isConflict ? t('notificationConflictMessage') : t('notificationEnableMessage')}
                </p>
                <div className="prompt-actions">
                    <button className="btn-prompt secondary" onClick={onCancel}>
                        {t('cancel')}
                    </button>
                    <button className="btn-prompt primary" onClick={onConfirm}>
                        {isConflict ? t('switchSession') : t('activate')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotificationPrompt;
// --- END OF FILE apps/reseye-web/src/components/NotificationPrompt.jsx ---
